import { useState } from 'react';
import { ICountDown, IRenderer } from './ICountDown';
import Countdown from 'react-countdown';
export default function CountDown({ countDownValue, resendOtp }: ICountDown) {
    const [timer, setTimer] = useState<number>(Date.now() + countDownValue);
    function handleOnChildClick() {
        setTimer(Date.now() + countDownValue);
        resendOtp();
    }
    const renderer = ({ hours, minutes, seconds, completed }: IRenderer) => {
        if (completed) {
            return (
                <span className="text-center text-xs primaryColorLight" onClick={handleOnChildClick}>
                    ارسال مجدد کد
                </span>
            );
        } else {
            // Render a countdown
            return (
                <p className="text-center primaryColorLight">
                    {(minutes < 10 ? '0' : '') + minutes}:
                    {(seconds < 10 ? '0' : '') + seconds}
                </p>
            );
        }
    };
    return <Countdown overtime={true} date={timer} renderer={renderer} />;
}
